import { render, staticRenderFns } from "./NavigationElement.vue?vue&type=template&id=0b456875&scoped=true&"
import script from "./NavigationElement.vue?vue&type=script&lang=js&"
export * from "./NavigationElement.vue?vue&type=script&lang=js&"
import style0 from "./NavigationElement.vue?vue&type=style&index=0&id=0b456875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b456875",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b456875')) {
      api.createRecord('0b456875', component.options)
    } else {
      api.reload('0b456875', component.options)
    }
    module.hot.accept("./NavigationElement.vue?vue&type=template&id=0b456875&scoped=true&", function () {
      api.rerender('0b456875', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/NavigationElement.vue"
export default component.exports